export default {
	BINDERS_LESSON_DELETE: 'BINDERS/LESSON_DELETE',
	BINDERS_BINDER_DELETE: 'BINDERS/BINDER_DELETE',
	COOKIES_DISABLED_ERROR: 'COOKIES/DISABLED_ERROR',
	CART_REMOVE: 'CART/REMOVE',
	PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM: 'PAYWALLS/NOT_ENOUGH_SPACE_CONFIRM',
	PAYWALL_PRESENTATION_SIZE_CONFIRM: 'PAYWALL/PRESENTATION_SIZE_CONFIRM',
	PRIVATE_LIBRARY_PAID_LESSONS_ADD: 'PRIVATE_LIBRARY/PAID_LESSONS_ADD',
	PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER: 'PRIVATE_LIBRARY/REMOVE_CURRENT_FOLDER',
	PRIVATE_LIBRARY_REMOVE_LESSON: 'PRIVATE_LIBRARY/REMOVE_LESSON',
	CART_ITEM_ADDED: 'CART/ITEM_ADDED',
	MY_ACCOUNT_ADVANCED_ENABLE_SETTING: 'MY_ACCOUNT/ADVANCED/ENABLE_SETTING',
	ADMIN_ONBOARDING_INVITE_CONFIRM: 'ADMIN_ONBOARDING/INVITE_CONFIRM',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRM: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_CONFIRM',
	SIGNUP_STUDENT_VALIDATION: 'SIGNUP/STUDENT_VALIDATION',
	QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR: 'QUIZ/UPLOAD_REFERENCE_MEDIA_ERROR',
	QUIZ_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR: 'QUIZ/UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR',
	QUIZ_INITIALIZE_ERROR: 'QUIZ/INITIALIZE_ERROR',
	QUIZ_CANCEL_CONFIRM: 'QUIZ/CANCEL_CONFIRM',
	MATCHING_PAIRS_PAIR_DELETE_CONFIRM: 'MATCHING_PAIRS/PAIR_DELETE_CONFIRM',
	MATCHING_PAIRS_CANCEL_CONFIRM: 'MATCHING_PAIRS/CANCEL_CONFIRM',
	STOREFRONT_REMOVE_LESSON: 'STOREFRONT/REMOVE_LESSON',
	USER_NOT_LOGGED_IN_CONFIRM: 'USER/NOT_LOGGED_IN_CONFIRM',
	DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM: 'DRAW_IT/AUDIO_PLAYER_DELETE_CONFIRM',
	DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM: 'DRAW_IT/AUDIO_RECORDER_DELETE_CONFIRM',
	DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR: 'DRAW_IT/UPLOAD_REFERENCE_MEDIA_ERROR',
	DRAW_IT_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR: 'DRAW_IT/UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR',
	DRAW_IT_CANCEL_CONFIRM: 'DRAW_IT/CANCEL_CONFIRM',
	OEQ_AUDIO_PLAYER_DELETE_CONFIRM: 'OEQ/AUDIO_PLAYER_DELETE_CONFIRM',
	OEQ_AUDIO_RECORDER_DELETE_CONFIRM: 'OEQ/AUDIO_RECORDER_DELETE_CONFIRM',
	OEQ_CANCEL_CONFIRM: 'OEQ/CANCEL_CONFIRM',
	OEQ_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR: 'OEQ/UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR',
	ONBOARDING_GUIDE_DISMISS_CONFIRM: 'ONBOARDING_GUIDE/DISMISS_CONFIRM',
	POLL_CANCEL_CONFIRM: 'POLL/CANCEL_CONFIRM',
	POLL_INITIALIZE_ERROR: 'POLL/INITIALIZE_ERROR',
	POLL_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR: 'POLL/UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR',
	POLL_UPLOAD_REFERENCE_MEDIA_ERROR: 'POLL/UPLOAD_REFERENCE_MEDIA_ERROR',
	PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT: 'PRIVATE_LIBRARY/ADD_TO_PRIVATE_LIBRARY_REDIRECT',
	MATCHING_PAIRS_UPLOAD_MEDIA_ERROR: 'MATCHING_PAIRS/UPLOAD_MEDIA_ERROR',
	PRIVATE_LIBRARY_ADD_TO_MULTIPLE_SCHOOLS: 'PRIVATE_LIBRARY/ADD_TO_MULTIPLE_SCHOOLS',
	PRIVATE_LIBRARY_REMOVE_LESSON_MULTIPLE_SCHOOLS: 'PRIVATE_LIBRARY/PRIVATE_LIBRARY_REMOVE_LESSON_MULTIPLE_SCHOOLS',
	MY_LIBRARY_HAS_SINGLE_SESSION: 'MY_LIBRARY/HAS_SINGLE_SESSION',
	MY_LIBRARY_EDIT_STORE_LESSON: 'MY_LIBRARY/EDIT_STORE_LESSON',
	MY_LIBRARY_PREMIUM_FEATURE_UPGRADE: 'MY_LIBRARY/PREMIUM_FEATURE_UPGRADE',
	GENERAL_CONFIRM: 'GENERAL/CONFIRM',
	MY_LIBRARY_DELETE_LESSON: 'MY_LIBRARY/DELETE_LESSON',
	MY_LIBRARY_SAVE_CHANGES_CONFIRM: 'MY_LIBRARY/SAVE_CHANGES_CONFIRM',
	MY_LIBRARY_REMOVE_FROM_FOLDER_CONFIRM: 'MY_LIBRARY/_REMOVE_FROM_FOLDER_CONFIRM',
	MY_LIBRARY_EXPORT_TO_PDF_CONFIRM: 'MY_LIBRARY/EXPORT_TO_PDF_CONFIRM',
	MY_LIBRARY_SAVE_LESSON_NOTIFY: 'MY_LIBRARY/SAVE_LESSON_NOTIFY',
	MY_LIBRARY_LESSON_ADDED_TO_PRIVATE_LIBRARY: 'MY_LIBRARY/LESSON_ADDED_TO_PRIVATE_LIBRARY',
	MY_LIBRARY_REMOVE_FOLDER_CONFIRM: 'MY_LIBRARY/REMOVE_FOLDER_CONFIRM',
	GENERAL_UPGRADE_CONFIRM: 'GENERAL/UPGRADE_CONFIRM',
	MY_LIBRARY_EDIT_STORE_LESSON_CONFIRM: 'MY_LIBRARY/EDIT_STORE_LESSON_CONFIRM',
	MY_LIBRARY_EDIT_RUNNING_LESSON_CONFIRM: 'MY_LIBRARY/EDIT_RUNNING_LESSON_CONFIRM',
	MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM: 'MY_LIBRARY/EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM',
	MY_LIBRARY_NO_LESSONS_LTI_CONFIRM: 'MY_LIBRARY/NO_LESSONS_LTI_CONFIRM',
	MY_LIBRARY_PAYWALL_STORAGE_CONFIRM: 'MY_LIBRARY/PAYWALL_STORAGE_CONFIRM',
	MY_LIBRARY_HOMEWORK_WITH_COLLABORATE_DISABLED: 'MY_LIBRARY/HOMEWORK_WITH_COLLABORATE_DISABLED',
	STUDENT_DELETE_AUDIO_OEQ_CONFIRM: 'STUDENT/DELETE_AUDIO_OEQ_CONFIRM',
	STUDENT_DRAW_IT_CLEAR_DRAWING: 'STUDENT/DRAW_IT/CLEAR_DRAWING',
	STUDENT_REQUEST_MIC_PERMISSION: 'STUDENT/REQUEST_MIC_PERMISSION',
	STUDENT_SLIDE_SUBMISSION_CONFIRM: 'STUDENT/SLIDE_SUBMISSION_CONFIRM',
	STUDENT_SUBMIT_DRAWIT_CONFIRMED: 'STUDENT/SUBMIT_DRAWIT_CONFIRMED',
	STUDENT_SUBMIT_DRAWIT_REQUIRED: 'STUDENT/SUBMIT_DRAWIT_REQUIRED',
	STUDENT_SUBMIT_POLL_CONFIRM: 'STUDENT/SUBMIT_POLL_CONFIRM',
	STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM: 'STUDENT/SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM',
	STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED: 'STUDENT/SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED',
	STUDENT_SUBMIT_POLL_CONFIRMED: 'STUDENT/SUBMIT_POLL_CONFIRMED',
	STUDENT_SUBMIT_POLL_EDIT: 'STUDENT/SUBMIT_POLL_EDIT',
	STUDENT_SUBMIT_POLL_CANCEL: 'STUDENT/SUBMIT_POLL_CANCEL',
	STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM: 'STUDENT/SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM',
	STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED: 'STUDENT/SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED',
	STUDENT_SUBMIT_QUIZ_CONFIRMED: 'STUDENT/SUBMIT_QUIZ_CONFIRMED',
	LOGIN_INITIALIZE: 'LOGIN/INITIALIZE',
	LMS_MODAL_CONFIRMED: 'LMS/MODAL_CONFIRMED',
	STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM: 'STUDENT/SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM',
	STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED: 'STUDENT/SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED',
	STUDENT_SUBMIT_OEQ_CONFIRMED: 'STUDENT/SUBMIT_OEQ_CONFIRMED',
	LOGIN_SSO_ERROR: 'LOGIN/SSO_ERROR',
	DESMOS_INITIALIZE_ERROR: 'DESMOS/INITIALIZE_ERROR',
	DESMOS_GET_RESULTS_ERROR: 'DESMOS/GET_RESULTS_ERROR',
	FEATURE_DOWNGRADE_FROM_PLATINUM_TO_GOLD: 26,
	FEATURE_AYCE_DOWNGRADE_ID: 11,
	FEATURE_DOWNGRADE_ID: 12,
	FEATURE_REDEEM_FAIL_ID: 16,
	FEATURE_SCHOOL_JOINED_NOTIFICATION: 13,
	FEATURE_SCHOOL_INVITED_NOTIFICATION: 14,
	FEATURE_SCHOOL_JOINED_NO_SLOTS_NOTIFICATION: 'FEATURE_SCHOOL_JOINED_NO_SLOTS_NOTIFICATION',
	FEATURE_PAYWALLS_REMINDER_ID: 8,
	FEATURE_PAYWALLS_EXPIRED_ID: 9,
	GAME_ACTIVITY_DELETE: 'GAME/ACTIVITY_DELETE',
	GAME_ACTIVITY_ANSWER_TYPE_TOGGLE: 'GAME/ACTIVITY_ANSWER_TYPE_TOGGLE',
	GAME_CANCEL: 'GAME/CANCEL',
	MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR: 'MY_LIBRARY/FIRST_LESSON_/FILE_PICKED_ERROR',
	MY_LIBRARY_DUPLICATE_CONFIRM: 'MY_LIBRARY/DUPLICATE_CONFIRM',
	GOOGLE_SLIDES_EDIT_NON_NEARPOD_SLIDE: 'GOOGLE_SLIDES/EDIT_NON_NEARPOD_SLIDE',
	GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRM: 'GOOGLE_SLIDES/SAVE_PRESENTATION_FAILED_CONFIRM',
	GOOGLE_SLIDES_SAVE_MEDIA_FAILED_CONFIRM: 'GOOGLE_SLIDES/SAVE_MEDIA_FAILED_CONFIRM',
	GOOGLE_SLIDES_POP_UP_BLOCKED_CONFIRM: 'GOOGLE_SLIDES/POP_UP_BLOCKED_CONFIRM',
	GOOGLE_SLIDES_EDIT_AUDIO_SLIDE: 'GOOGLE_SLIDES/EDIT_AUDIO_SLIDE',
	GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRM: 'GOOGLE_SLIDES/LMS_OPEN_GOOGLE_CONFIRM',
	GOOGLE_SLIDES_LMS_REFRESH_CONFIRM: 'GOOGLE_SLIDES/LMS_REFRESH_CONFIRM',
	GOOGLE_SLIDES_UNAUTHORIZED_USER_EDIT: 'GOOGLE_SLIDES/UNAUTHORIZED_USER_EDIT',
	STUDENT_SUBMIT_FAILED_CONFIRM: 'STUDENT/SUBMIT_FAILED_CONFIRM',
	QUICK_LAUNCH_LAUNCH_LESSON_FAILED: 'QUICK_LAUNCH/LAUNCH_LESSON_FAILED',
	INTERACTIVE_VIDEO_EXIT_SELECTED: 'INTERACTIVE_VIDEO/EXIT_SELECTED',
	STUDENT_LEAD_MESSAGE: 'STUDENT/LEAD_MESSAGE',
	MY_LIBRARY_LESSON_LAUNCH_FAILED: 'MY_LIBRARY/LESSON_LAUNCH_FAILED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_CONFIRM: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/CANCEL_CONFIRM',
	FEATURE_INTERACTIVE_VIDEO_IM_TOGGLE_CONFIRM_ID: 'FEATURE_INTERACTIVE_VIDEO_IM_TOGGLE_CONFIRM_ID',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_CONFIRM: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE_CONFIRM',
	INTERACTIVE_VIDEO_SUBMIT_SUCCESS_LIVE: 'INTERACTIVE_VIDEO/SUBMIT_SUCCESS_LIVE',
	INTERACTIVE_VIDEO_SUBMIT_SUCCESS_SP: 'INTERACTIVE_VIDEO/SUBMIT_SUCCESS_SP',
	INTERACTIVE_VIDEO_BLANK_RESPONSE_PROMPT_OEQ: 'INTERACTIVE_VIDEO/BLANK_RESPONSE_PROMPT_OEQ',
	INTERACTIVE_VIDEO_BLANK_RESPONSE_PROMPT_MCQ: 'INTERACTIVE_VIDEO/BLANK_RESPONSE_PROMPT_MCQ',
	INTERACTIVE_VIDEO_SUBMISSIONS_REQUIRED: 'INTERACTIVE_VIDEO/SUBMISSIONS_REQUIRED',
	INTERACTIVE_VIDEO_BREAKPOINT_ACCESS: 'INTERACTIVE_VIDEO/BREAKPOINT_ACCESS',
	INTERACTIVE_VIDEO_PREVENT_SKIPPING_PROMPT: 'INTERACTIVE_VIDEO/PREVENT_SKIPPING_PROMPT',
	INTERACTIVE_VIDEO_STREAM_MODE_SELECT: 'INTERACTIVE_VIDEO/STREAM_MODE_SELECT',
	FEATURE_INTERACTIVE_VIDEO_POST_SESSION_INFORMATION_CONFIRM_ID: 'FEATURE_INTERACTIVE_VIDEO_POST_SESSION_INFORMATION_CONFIRM_ID',
	VIDEO_CANCEL_CONFIRM: 'VIDEO/CANCEL_CONFIRM',
	INTERACTIVE_VIDEO_CREATION_CANCEL_CONFIRM: 'INTERACTIVE_VIDEO_CREATION/CANCEL_CONFIRM',
	STUDENT_NO_ACCOUNT_CONFIRM: 'STUDENT/NO_ACCOUNT_CONFIRM',
	ACTIVITY_REPLACE: 'ACTIVITY/REPLACE',
}
